import store from "../../store"
import { industrializationCostsLocation } from '../articoli/costi/navigation.mjs';


const AttrezzaturaList = () => import("./AttrezzaturaList.vue")
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    next('/login')
}

export default [
    {
        path:'/attrezzature/industrializzazione/nuova',
        name:'industrializzazione-nuova',
        meta:{menu:'attrezzature',title:'Nuova richiesta di industrializzazione'},
        component:()=>import('./industrializzazione/IndustrializationNewRequest.vue'),
        beforeEnter:(to,from,next)=>store.getters.isLoggedIn ? next() : next({path:'/login',query:{next:to.fullPath}}),
    },
    {
        path:'/attrezzature/industrializzazione/progetti/:identifier',
        name:'industrializzazione-progetto',
        meta:{menu:'attrezzature',title:'Progetto attrezzatura'},
        component:()=>import('./industrializzazione/IndustrializationProject.vue'),
        beforeEnter:(to,from,next)=>store.getters.isLoggedIn ? next() : next({path:'/login',query:{next:to.fullPath}}),
    },
    {
        path: '/ufficio-tecnico/avanzamento/',
        name: 'ufficio-tecnico-avanzamento',
        meta: { menu: 'attrezzature', title: 'Avanzamento ufficio tecnico' },
        component: () => import('./industrializzazione/TechnicalOfficeAdvancement.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/attrezzature/industrializzazione/analisi-ciclo/:codice?',
        redirect: to => industrializationCostsLocation(to.params.codice, to.query, to.hash),
    },
    {
        path: '/attrezzature/industrializzazione/:view?/:codice?',
        name: 'attrezzature-industrializzazione',
        meta: { menu: 'attrezzature', title: 'Industrializzazione' },
        component: () => import('./Industrializzazione.vue'),
        beforeEnter: (to, from, next) => {
            if (!store.getters.isLoggedIn) return next('/login');
            if (to.params.view === 'analisi-ciclo') return next(industrializationCostsLocation(to.params.codice, to.query, to.hash));
            const validViews = ['', 'candidati', 'nuovi', 'analisi-ciclo', 'sviluppo', 'assegnazioni', 'qualita-dati', 'definizioni'];
            if (!validViews.includes(to.params.view || '')) return next('/attrezzature/industrializzazione');
            next();
        },
    },
    {
        path: '/attrezzature/list/',
        name: 'attrezzature-list',
        meta: {menu: 'attrezzature', title: 'Lista Attrezzature'},
        component: AttrezzaturaList,
        beforeEnter: ifAuthenticated,
    },
]
